/* import __COLOCATED_TEMPLATE__ from './evalboard-confirmation.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { assert } from '@ember/debug';
import { isNone } from '@ember/utils';
import type IntlService from 'ember-intl/services/intl';

interface EvalboardConfirmationDialogArgs {
  // Parameters
  title: string;
  confirm: () => void;
  close: () => void;
  message?: string;
  proceedButtonText?: string;
  cancelButtonText?: string;
  dialogClass?: string;
}
export default class EvalboardConfirmationDialog extends Component<EvalboardConfirmationDialogArgs> {
  @service declare intl: IntlService;

  constructor(owner: unknown, args: EvalboardConfirmationDialogArgs) {
    super(owner, args);
    assert('`title` is required', !isNone(this.args.title));
    assert('`confirm` is required', !isNone(this.args.confirm));
    assert('`close` is required', !isNone(this.args.close));
  }

  // Optional parameters with defaults applied
  get _proceedButtonText() {
    return this.args.proceedButtonText ?? this.intl.t('ember-aditools-page.common.ok');
  }

  get _cancelButtonText() {
    return this.args.cancelButtonText ?? this.intl.t('ember-aditools-page.common.cancel');
  }

  ////////////////////////////////////////////////////////////////////////////////
  // Component Actions                                                          //
  ////////////////////////////////////////////////////////////////////////////////
  @action proceed(closeDialog: () => void): void {
    if (this.args.confirm) {
      this.args.confirm();
    }
    closeDialog();
  }
}
